(() => {
	const filterItems = document.querySelectorAll<HTMLDivElement>(".filter-item");
	filterItems.forEach((ele) => {
		ele.addEventListener("click", (_e) => {
			const searchParams = new URLSearchParams(location.search);
			let types = searchParams.get("types")?.split(",") || [];
			const value = ele.getAttribute("data-value");
			if (!value) {
				return;
			}
			const isChecked = types.includes(value);
			if (!isChecked) {
				types.push(value);
			} else {
				types = types.filter((t) => t !== value);
			}
			searchParams.set("types", types.filter((t) => !!t).join(","));
			location.href = `${location.pathname}?${searchParams.toString()}`;
		});
	});
})();
